export default "__VITE_ASSET__01600b16__"